import { calculateTotalPages } from '../util'

export const ERROR_MESSAGE_VB_IN_MEETINGS =
  'Virtual Backgrounds can be used only in meetings. To use it, click “Apps” in your meeting window and open Virtual Backgrounds.'
export const ERROR_MESSAGE_GENERIC =
  'Please refresh to continue using Virtual Backgrounds'
export const RESULTS_FOUND = (number, query, page = 1) =>
  `Found ${number} results for ${query}, currently on page ${page} out of ${calculateTotalPages(
    number
  )}`
export const INMAINCLIENT_SUPPORT_FROM_DESKTOP_CLIENT_VERSION = '5.13.5'
export const INMAINCLIENT_SUPPORT_FROM_IOS_CLIENT_VERSION = '5.13.10'
